export const articles = [
  {
    id: "1",
    title: "千万网红\u201c塌房\u201d全过程曝光：粉丝群聊天记录流出",
    slug: "wanghong-tafang-quan-guocheng",
    excerpt: "某平台头部网红近日被爆出大量负面消息，粉丝群内部聊天记录流出，涉及虚假宣传、团队内讧等内幕。据知情人透露，该网红团队已于上周解散...",
    category: "网红圈",
    categorySlug: "wanghong",
    author: "吃瓜小助手",
    publishDate: "2026-07-02",
    readCount: 128560,
    commentCount: 3421,
    isHot: true,
    isTop: true,
    imageUrl: "https://readdy.ai/api/search-image?query=Social%20media%20influencer%20scandal%20concept%2C%20dramatic%20red%20and%20dark%20background%2C%20broken%20smartphone%20screen%2C%20abstract%20digital%20art%2C%20moody%20atmosphere%2C%20editorial%20illustration%2C%20minimalist%20composition&width=800&height=500&seq=article-01&orientation=landscape",
    tags: ["网红", "塌房", "聊天记录"],
  },
  {
    id: "2",
    title: "某一线男星被曝隐婚生子，工作室紧急发声明",
    slug: "nanxing-yinhun-shengzi-shengming",
    excerpt: "昨日凌晨，某知名男星被狗仔拍到与神秘女子共同出入月子中心，疑似已隐婚生子。该男星工作室在事件发酵三小时后紧急发布声明...",
    category: "娱乐圈",
    categorySlug: "yule",
    author: "娱乐前线",
    publishDate: "2026-07-01",
    readCount: 98520,
    commentCount: 2786,
    isHot: true,
    isTop: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Celebrity%20paparazzi%20scandal%20concept%2C%20dark%20theater%20spotlights%2C%20silhouette%20of%20couple%2C%20mystery%20atmosphere%2C%20cinematic%20red%20and%20black%20tones%2C%20dramatic%20lighting%2C%20editorial%20art&width=800&height=500&seq=article-02&orientation=landscape",
    tags: ["男星", "隐婚", "狗仔"],
  },
  {
    id: "3",
    title: "热门综艺幕后大揭秘：选手互撕、导演甩锅全记录",
    slug: "zongyi-muhou-jiemi-xuanshou-husi",
    excerpt: "某热播选秀综艺近日被工作人员爆料幕后真相，选手之间明争暗斗、导演组甩锅操作等内幕一一浮出水面，令观众大跌眼镜...",
    category: "娱乐圈",
    categorySlug: "yule",
    author: "综艺侦察兵",
    publishDate: "2026-07-01",
    readCount: 76340,
    commentCount: 1953,
    isHot: true,
    isTop: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20TV%20show%20drama%2C%20backstage%20chaos%20concept%2C%20clapperboard%20with%20cracks%2C%20dark%20red%20ambient%20lighting%2C%20abstract%20theatrical%20composition%2C%20editorial%20illustration&width=800&height=500&seq=article-03&orientation=landscape",
    tags: ["综艺", "选秀", "内幕"],
  },
  {
    id: "4",
    title: "某大厂\u201c优化\u201d名单曝光：涉及多个核心部门",
    slug: "dachang-youhua-mingdan-baoguang",
    excerpt: "某互联网巨头内部\u201c优化\u201d名单近日在脉脉等平台流出，涉及技术、产品、运营等多个核心部门，总计人数超过此前预期。多位被裁员工表示...",
    category: "社会热点",
    categorySlug: "shehui",
    author: "职场观察员",
    publishDate: "2026-06-30",
    readCount: 112300,
    commentCount: 5678,
    isHot: true,
    isTop: true,
    imageUrl: "https://readdy.ai/api/search-image?query=Corporate%20layoff%20concept%2C%20empty%20office%20cubicles%2C%20single%20desk%20lamp%20on%2C%20dark%20moody%20atmosphere%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20editorial%20photography%20style&width=800&height=500&seq=article-04&orientation=landscape",
    tags: ["大厂", "裁员", "优化"],
  },
  {
    id: "5",
    title: "外卖小哥送餐途中见义勇为，全网点赞！",
    slug: "waimai-xiaoge-jianyi-yongwei-quanwang",
    excerpt: "昨日下午，一名外卖小哥在送餐途中偶遇老人落水，毫不犹豫跳入河中救人。视频被路人拍下上传网络后迅速走红，短短三小时收获百万点赞...",
    category: "社会热点",
    categorySlug: "shehui",
    author: "正能量播报",
    publishDate: "2026-06-30",
    readCount: 215600,
    commentCount: 8932,
    isHot: false,
    isTop: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Food%20delivery%20hero%20concept%2C%20warm%20sunset%20urban%20street%2C%20delivery%20scooter%20with%20glowing%20lights%2C%20heroic%20silhouette%2C%20warm%20orange%20and%20amber%20tones%2C%20inspiring%20atmosphere%2C%20cinematic%20composition&width=800&height=500&seq=article-05&orientation=landscape",
    tags: ["外卖小哥", "正能量", "见义勇为"],
  },
  {
    id: "6",
    title: "百万博主分手互撕后续：前任晒出转账记录",
    slug: "bovan-bozhu-fenshou-husi-zhuanzhang",
    excerpt: "前日闹得沸沸扬扬的百万粉博主分手风波又有新进展，男方晒出多张转账截图，涉及金额累计超百万。女方随后回应，称款项为合作分成...",
    category: "情感八卦",
    categorySlug: "qinggan",
    author: "情感调解员",
    publishDate: "2026-06-29",
    readCount: 156780,
    commentCount: 4521,
    isHot: true,
    isTop: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Breakup%20drama%20social%20media%20concept%2C%20split%20smartphone%20screen%20showing%20messages%2C%20broken%20heart%20fragments%2C%20dark%20dramatic%20red%20background%2C%20digital%20art%20editorial%20style&width=800&height=500&seq=article-06&orientation=landscape",
    tags: ["分手", "互撕", "转账"],
  },
  {
    id: "7",
    title: "某手机品牌发布会翻车：现场演示出现重大Bug",
    slug: "shouji-pinpaifabuhui-fanche-bug",
    excerpt: "昨日某知名手机品牌新品发布会上，演示环节出现严重技术故障，演示机当场死机，现场一片尴尬。品牌方随后解释称是演示环境问题...",
    category: "科技数码",
    categorySlug: "keji",
    author: "数码评测君",
    publishDate: "2026-06-29",
    readCount: 89400,
    commentCount: 3102,
    isHot: false,
    isTop: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Tech%20product%20launch%20fail%20concept%2C%20smartphone%20with%20error%20screen%20on%20stage%2C%20spotlight%20beam%2C%20dark%20stage%20atmosphere%2C%20red%20warning%20light%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=article-07&orientation=landscape",
    tags: ["发布会", "翻车", "Bug"],
  },
  {
    id: "8",
    title: "高校食堂\u201c黑暗料理\u201d上新：学生纷纷打卡拍照",
    slug: "gaoxiao-shitang-heian-liaoli-daka",
    excerpt: "某高校食堂近日推出一道创意料理，因其独特造型引发学生围观，纷纷拍照上传社交平台。有网友评论：\u201c这菜我爷爷看了都摇头\u201d...",
    category: "搞笑趣闻",
    categorySlug: "gaoxiao",
    author: "校园观察家",
    publishDate: "2026-06-28",
    readCount: 67890,
    commentCount: 2341,
    isHot: false,
    isTop: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Funny%20bizarre%20food%20concept%2C%20creative%20dish%20plating%20with%20unusual%20shapes%2C%20warm%20cafeteria%20lighting%2C%20colorful%20whimsical%20atmosphere%2C%20soft%20amber%20tones%2C%20editorial%20food%20photography&width=800&height=500&seq=article-08&orientation=landscape",
    tags: ["高校", "食堂", "黑暗料理"],
  },
  {
    id: "9",
    title: "直播带货\u201c翻车\u201d现场：主播试吃直接吐出来",
    slug: "zhibo-daihuo-fanche-zhubo-tuchu",
    excerpt: "某主播在直播带货过程中试吃推销产品，因口味问题当场表情失控，直接吐了出来，直播间弹幕瞬间炸锅。该片段被网友录屏疯传...",
    category: "网红圈",
    categorySlug: "wanghong",
    author: "直播扒皮手",
    publishDate: "2026-06-28",
    readCount: 145230,
    commentCount: 6789,
    isHot: true,
    isTop: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Live%20streaming%20fail%20concept%2C%20microphone%20with%20shocked%20expression%20aura%2C%20dark%20studio%20background%2C%20red%20warning%20glow%2C%20dramatic%20spotlight%2C%20editorial%20digital%20art%20illustration&width=800&height=500&seq=article-09&orientation=landscape",
    tags: ["直播", "带货", "翻车"],
  },
  {
    id: "10",
    title: "某女星红毯造型引争议：造型师评论区沦陷",
    slug: "nvxing-hongtan-zaoxing-zheng-yi",
    excerpt: "某知名女星昨晚出席国际电影节红毯，其造型引发网友热议。大量粉丝涌入造型师社交媒体评论区，要求\u201c换人\u201d。造型师尚未回应...",
    category: "娱乐圈",
    categorySlug: "yule",
    author: "时尚侦探",
    publishDate: "2026-06-27",
    readCount: 56780,
    commentCount: 1890,
    isHot: false,
    isTop: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Red%20carpet%20fashion%20controversy%20concept%2C%20elegant%20gown%20with%20dramatic%20lighting%2C%20spotlights%20and%20camera%20flashes%2C%20glamorous%20dark%20background%2C%20gold%20and%20warm%20tones%2C%20editorial%20fashion%20photography&width=800&height=500&seq=article-10&orientation=landscape",
    tags: ["红毯", "造型", "争议"],
  },
  {
    id: "11",
    title: "网红情侣宣布分手：双方各执一词，网友站队激烈",
    slug: "wanghong-qinglv-fenshou-shuangfang-gezhi",
    excerpt: "粉丝超五百万的网红情侣今日同时发布分手声明，但双方说法完全相反。男方称女方\u201c出轨在先\u201d，女方则回应\u201c长期冷暴力\u201d...",
    category: "情感八卦",
    categorySlug: "qinggan",
    author: "情感前线",
    publishDate: "2026-06-27",
    readCount: 198760,
    commentCount: 8921,
    isHot: true,
    isTop: true,
    imageUrl: "https://readdy.ai/api/search-image?query=Influencer%20couple%20breakup%20drama%2C%20two%20smartphones%20facing%20away%20from%20each%20other%2C%20broken%20connection%20concept%2C%20dark%20dramatic%20red%20background%2C%20social%20media%20icons%20floating%2C%20editorial%20digital%20art&width=800&height=500&seq=article-11&orientation=landscape",
    tags: ["网红情侣", "分手", "站队"],
  },
  {
    id: "12",
    title: "城市地铁\u201c神评论\u201d合集：乘客们的脑洞有多大？",
    slug: "ditie-shen-pinglun-heji-naodong",
    excerpt: "近日有网友整理了一组地铁车厢内的趣味对话和偶遇，从\u201c阿姨教穿搭\u201d到\u201c小朋友金句\u201d，笑料百出，引发大量转发和模仿...",
    category: "搞笑趣闻",
    categorySlug: "gaoxiao",
    author: "地铁观察员",
    publishDate: "2026-06-26",
    readCount: 43200,
    commentCount: 1234,
    isHot: false,
    isTop: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Subway%20metro%20humor%20concept%2C%20crowded%20train%20interior%20with%20warm%20lighting%2C%20speech%20bubbles%20floating%20above%20passengers%2C%20whimsical%20editorial%20style%2C%20warm%20amber%20and%20soft%20red%20accents&width=800&height=500&seq=article-12&orientation=landscape",
    tags: ["地铁", "神评论", "搞笑"],
  },
];

export const hotArticles = [
  {
    rank: 1,
    title: "千万网红\u201c塌房\u201d全过程曝光：粉丝群聊天记录流出",
    slug: "wanghong-tafang-quan-guocheng",
    readCount: 128560,
    heat: 98,
  },
  {
    rank: 2,
    title: "某大厂\u201c优化\u201d名单曝光：涉及多个核心部门",
    slug: "dachang-youhua-mingdan-baoguang",
    readCount: 112300,
    heat: 95,
  },
  {
    rank: 3,
    title: "外卖小哥送餐途中见义勇为，全网点赞！",
    slug: "waimai-xiaoge-jianyi-yongwei-quanwang",
    readCount: 215600,
    heat: 93,
  },
  {
    rank: 4,
    title: "网红情侣宣布分手：双方各执一词，网友站队激烈",
    slug: "wanghong-qinglv-fenshou-shuangfang-gezhi",
    readCount: 198760,
    heat: 91,
  },
  {
    rank: 5,
    title: "直播带货\u201c翻车\u201d现场：主播试吃直接吐出来",
    slug: "zhibo-daihuo-fanche-zhubo-tuchu",
    readCount: 145230,
    heat: 88,
  },
  {
    rank: 6,
    title: "百万博主分手互撕后续：前任晒出转账记录",
    slug: "bovan-bozhu-fenshou-husi-zhuanzhang",
    readCount: 156780,
    heat: 86,
  },
  {
    rank: 7,
    title: "某一线男星被曝隐婚生子，工作室紧急发声明",
    slug: "nanxing-yinhun-shengzi-shengming",
    readCount: 98520,
    heat: 84,
  },
  {
    rank: 8,
    title: "热门综艺幕后大揭秘：选手互撕、导演甩锅全记录",
    slug: "zongyi-muhou-jiemi-xuanshou-husi",
    readCount: 76340,
    heat: 82,
  },
  {
    rank: 9,
    title: "某手机品牌发布会翻车：现场演示出现重大Bug",
    slug: "shouji-pinpaifabuhui-fanche-bug",
    readCount: 89400,
    heat: 78,
  },
  {
    rank: 10,
    title: "高校食堂\u201c黑暗料理\u201d上新：学生纷纷打卡拍照",
    slug: "gaoxiao-shitang-heian-liaoli-daka",
    readCount: 67890,
    heat: 75,
  },
];